<div class='buyer-v2-page' *appPermissionCheck='ComponentPermission.CUSTOMER_LIST'>
  <div class='row m-0 buyer-v2-layout'>
    <div class='col-md-7 col-sm-12 left-panel table-container' [ngClass]="{'popup-hide': isDisplay}">
      <nb-card class='buyer-v2-card'>
        <nb-card-body>
          <div class='buyer-v2-actions buyer-v2-actions--primary'>
            <button nbButton size='tiny' class='buyer-v2-action-btn buyer-v2-action-primary-row' (click)='openNewBuyer()'>New</button>
            <button nbButton size='tiny' class='buyer-v2-action-btn buyer-v2-action-primary-row' (click)='exportMobile()'>Mobile</button>
            <button nbButton size='tiny' class='buyer-v2-action-btn buyer-v2-action-primary-row' (click)='exportAddress()'>Address</button>
            <span class='buyer-v2-action-break'></span>
            <button nbButton size='tiny' class='buyer-v2-action-btn buyer-v2-action-search-row'
                    [ngClass]="{'buyer-v2-action-btn--active': searchMode}"
                    (click)='openDetailSearch()'>Detail Search</button>
            <button nbButton size='tiny' class='buyer-v2-action-btn buyer-v2-action-btn--active buyer-v2-action-search-row' (click)='onSearchButtonClick()'>Search</button>
          </div>

          <div class='buyer-v2-filters' *ngIf='showAdvance'>
            <div class='buyer-v2-grid buyer-v2-grid--dates'>
              <select class='select-custom' [(ngModel)]='selectedDay' [disabled]='!selectedWeek' (change)='onDayChange()'>
                <option [ngValue]='undefined'>Day</option>
                <option *ngFor='let item of days' [value]='item'>{{ item }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='selectedWeek' [disabled]='!selectedMonth' (change)='onWeekChange()'>
                <option [ngValue]='undefined'>Week</option>
                <option *ngFor='let item of weeks' [value]='item'>{{ item }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='selectedMonth' [disabled]='!selectedYear' (change)='onMonthChange()'>
                <option [ngValue]='undefined'>Month</option>
                <option *ngFor='let item of months' [value]='item'>{{ item }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='selectedYear' (change)='onYearChange()'>
                <option [ngValue]='undefined'>Year</option>
                <option *ngFor='let item of years' [value]='item'>{{ item }}</option>
              </select>
            </div>

            <div class='buyer-v2-grid'>
              <select class='select-custom' [(ngModel)]='searchRequest.code'>
                <option [ngValue]='undefined'>Class</option>
                <option *ngFor='let option of classOptions' [value]='option'>{{ option }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.rate'>
                <option [ngValue]='undefined'>Rate</option>
                <option *ngFor='let option of rateOptions' [value]='option.value'>{{ option.label }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.isActive'>
                <option [ngValue]='undefined'>Status</option>
                <option *ngFor='let option of statusOptions' [value]='option'>{{ option }}</option>
              </select>
              <input
                [(ngModel)]='categoryName'
                [ngModelOptions]='{standalone: true}'
                [typeahead]='filterCategory$'
                [typeaheadAsync]='true'
                (typeaheadOnSelect)='selectCategory($event)'
                typeaheadOptionField='name'
                typeaheadWaitMs='500'
                class='buyer-v2-input'
                placeholder='Tag'
                nbInput
                fieldSize='tiny'
                fullWidth>
            </div>

            <div class='buyer-v2-actions buyer-v2-mode-filter buyer-v2-mode-filter--buyer'>
              <div class='buyer-v2-summary'>Total buyers: {{ totalRecords }}</div>
              <button nbButton size='tiny'
                      class='buyer-v2-action-btn buyer-v2-action-primary-row'
                      [ngClass]="{'buyer-v2-action-btn--active': buyerMode === 'B'}"
                      (click)='setBuyerMode("B")'>B</button>
              <button nbButton size='tiny'
                      class='buyer-v2-action-btn buyer-v2-action-primary-row'
                      [ngClass]="{'buyer-v2-action-btn--active': buyerMode === 'T'}"
                      (click)='setBuyerMode("T")'>T</button>
            </div>
            <div class='buyer-v2-tags' *ngIf='selectedCategories.length > 0'>
              <div class='buyer-v2-tag' *ngFor='let category of selectedCategories'>
                <span>{{ category.name }}</span>
                <button type='button' class='buyer-v2-tag-remove' (click)='removeCategory(category)'>
                  <i class='fa fa-times'></i>
                </button>
              </div>
            </div>
          </div>

          <div class='buyer-v2-empty' *ngIf='!isLoading && buyers.length === 0'>No buyers found</div>

          <div class='buyer-v2-list' *ngIf='buyers.length > 0'>
            <div class='buyer-v2-list-actions'>
              <div class='buyer-v2-check buyer-v2-check--header'>
                <nb-checkbox [(ngModel)]='allChecked' (checkedChange)='toggleAllSelection($event)'></nb-checkbox>
              </div>
              <button *ngIf='selectedBuyerIds.length > 0' nbButton size='tiny' class='buyer-v2-clear-btn' (click)='clearSelection()'>
                Clear Selected
              </button>
              <button *ngIf='selectedBuyerRecordIds.length > 1'
                      nbButton
                      size='tiny'
                      class='buyer-v2-action-btn buyer-v2-action-btn--active buyer-v2-apply-all-btn'
                      (click)='applyAll()'>Apply All</button>
            </div>

            <div
              class='buyer-v2-item'
              *ngFor='let buyer of buyers'
              [ngClass]="{
                'buyer-v2-item--selected': selectedBuyer?.buyerId === buyer.buyerId,
                'buyer-v2-item--highlight': buyer?.rate >= 4,
                'buyer-v2-item--wot': buyer?.isWot
              }">
              <div class='buyer-v2-check'>
                <nb-checkbox
                  [checked]='isSelected(buyer)'
                  (checkedChange)='toggleBuyerSelection(buyer, $event)'>
                </nb-checkbox>
              </div>
              <div class='buyer-v2-content' (click)='selectBuyer(buyer)'>
                <div class='buyer-v2-main'>
                  <div class='buyer-v2-name'>
                    {{ getName(buyer) || 'Unnamed Buyer' }}
                    <span *ngIf='getTags(buyer)'>({{ getTags(buyer) }})</span>
                  </div>
                  <div class='buyer-v2-address'>{{ getAddress(buyer) }}</div>
                </div>
                <div class='buyer-v2-side'>
                  <div class='buyer-v2-classification'>{{ getClassification(buyer) }}</div>
                  <div class='buyer-v2-meta' [class.buyer-v2-meta--price]='isPriceText(buyer)'>
                    {{ getRightBottomText(buyer) }}
                  </div>
                </div>
              </div>
            </div>

            <nav class='buyer-v2-pagination' *ngIf='totalPages > 1'>
              <ul class='pagination justify-content-center'>
                <li class='page-item pointer' [ngClass]='currentPage === 1 ? "disabled" : ""'>
                  <span class='page-link' (click)='pageChange(null, false)'>Previous</span>
                </li>
                <li class='page-item pointer' *ngFor='let page of pages' [ngClass]='currentPage === page ? "active" : ""'>
                  <span class='page-link' (click)='pageChange(page)'>{{ page }}</span>
                </li>
                <li class='page-item pointer' [ngClass]='currentPage === totalPages ? "disabled" : ""'>
                  <span class='page-link' (click)='pageChange(null, true)'>Next</span>
                </li>
              </ul>
            </nav>
          </div>
        </nb-card-body>
      </nb-card>
    </div>

    <div class='col-md-5 pl-0 col-sm-12 right-panel table-right-container buyer-v2-detail'
         [ngClass]="{'popup-detail': isDisplay, 'hide-detail': !isDisplay}">
      <nb-card *ngIf='searchMode' class='buyer-v2-search-card'>
        <nb-card-header class='buyer-v2-search-header'>
          <button
            type='button'
            nbButton
            size='large'
            class='buyer-v2-search-back-button'
            aria-label='Back'
            (click)='cancelDetailSearch()'>
            <nb-icon icon='arrow-back-outline' pack='eva'></nb-icon>
          </button>
        </nb-card-header>
        <nb-card-body class='buyer-v2-search-body'>
          <section class='buyer-v2-search-section'>
            <div class='buyer-v2-search-title'>Customer</div>
            <div class='buyer-v2-search-grid'>
              <input nbInput fieldSize='tiny' fullWidth placeholder='Name' [(ngModel)]='searchRequest.name'>
              <input nbInput fieldSize='tiny' fullWidth placeholder='Surname' [(ngModel)]='searchRequest.surname'>
              <input nbInput fieldSize='tiny' fullWidth placeholder='Phone Number' [(ngModel)]='searchRequest.phone'>
              <input nbInput fieldSize='tiny' fullWidth placeholder='Email' [(ngModel)]='searchRequest.email'>
            </div>
          </section>

          <section class='buyer-v2-search-section'>
            <div class='buyer-v2-search-title'>Classification</div>
            <div class='buyer-v2-search-grid'>
              <select class='select-custom' [(ngModel)]='searchRequest.buyerCode'
                      (ngModelChange)='onSearchBuyerCodeChange($event)'>
                <option [ngValue]='undefined'>Buyer / Tenant</option>
                <option value='B'>Buyer</option>
                <option value='T'>Tenant</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.code'>
                <option [ngValue]='undefined'>Class</option>
                <option *ngFor='let option of classOptions' [value]='option'>{{ option }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.rate'>
                <option [ngValue]='undefined'>Rate</option>
                <option *ngFor='let option of rateOptions' [value]='option.value'>{{ option.label }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.isActive'>
                <option [ngValue]='undefined'>Status</option>
                <option *ngFor='let option of statusOptions' [value]='option'>{{ option }}</option>
              </select>
              <input
                [(ngModel)]='categoryName'
                [ngModelOptions]='{standalone: true}'
                [typeahead]='filterCategory$'
                [typeaheadAsync]='true'
                (typeaheadOnSelect)='selectCategory($event)'
                typeaheadOptionField='name'
                typeaheadWaitMs='500'
                class='buyer-v2-input buyer-v2-search-grid-wide'
                placeholder='Tag'
                nbInput fieldSize='tiny' fullWidth>
            </div>
            <div class='buyer-v2-tags' *ngIf='selectedCategories.length > 0'>
              <div class='buyer-v2-tag' *ngFor='let category of selectedCategories'>
                <span>{{ category.name }}</span>
                <button type='button' class='buyer-v2-tag-remove' (click)='removeCategory(category)'>
                  <i class='fa fa-times'></i>
                </button>
              </div>
            </div>
          </section>

          <section class='buyer-v2-search-section'>
            <div class='buyer-v2-search-title'>Property</div>
            <div class='buyer-v2-search-grid buyer-v2-search-grid--property'>
              <select class='select-custom' [(ngModel)]='searchRequest.propertyType'>
                <option [ngValue]='undefined'>Type</option>
                <option *ngFor='let option of propertyTypeOptions' [value]='option.key'>{{ option.label }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.bed'>
                <option [ngValue]='undefined'>Bed</option>
                <option *ngFor='let option of propertySpecOptions' [value]='option'>{{ option }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.bath'>
                <option [ngValue]='undefined'>Bath</option>
                <option *ngFor='let option of propertySpecOptions' [value]='option'>{{ option }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.car'>
                <option [ngValue]='undefined'>Car</option>
                <option *ngFor='let option of propertySpecOptions' [value]='option'>{{ option }}</option>
              </select>
              <input type='text' inputmode='decimal' nbInput fieldSize='tiny' fullWidth placeholder='Min Budget'
                     [(ngModel)]='searchRequest.fromMinBuyPrice'>
              <input type='text' inputmode='decimal' nbInput fieldSize='tiny' fullWidth placeholder='Max Budget'
                     [(ngModel)]='searchRequest.toMaxBuyPrice'>
            </div>
          </section>

          <section class='buyer-v2-search-section'>
            <div class='buyer-v2-search-title'>Area Enquiring</div>
            <div class='buyer-v2-search-grid'>
              <input type='text' inputmode='numeric' nbInput fieldSize='tiny' fullWidth placeholder='Postcode'
                     [(ngModel)]='searchRequest.areaPostcode'
                     (ngModelChange)='onAreaPostcodeChange($event)'>
              <select class='select-custom' [(ngModel)]='searchRequest.areaDistrictId'
                      [disabled]='!searchRequest.areaPostcode'
                      (change)='onAreaDistrictChange(searchRequest.areaDistrictId)'>
                <option [ngValue]='undefined'>Suburb</option>
                <option *ngFor='let district of areaDistricts' [value]='district.districtId'>{{ district.name }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.areaStreetId'
                      [disabled]='!searchRequest.areaDistrictId'>
                <option [ngValue]='undefined'>Street</option>
                <option *ngFor='let street of areaStreets' [value]='street.streetId'>{{ street.name }}</option>
              </select>
              <input nbInput fieldSize='tiny' fullWidth placeholder='From' [(ngModel)]='searchRequest.areaNumberFrom'>
              <input nbInput fieldSize='tiny' fullWidth placeholder='To' [(ngModel)]='searchRequest.areaNumberTo'>
            </div>
          </section>

          <section class='buyer-v2-search-section'>
            <div class='buyer-v2-search-title'>Preferred Area</div>
            <div class='buyer-v2-search-grid'>
              <input nbInput fieldSize='tiny' fullWidth class='buyer-v2-search-grid-wide' placeholder='Select postcode'
                     inputmode='numeric' maxlength='4'
                     [(ngModel)]='preferredPostcodeInput'
                     [ngModelOptions]='{standalone: true}'
                     [typeahead]='filterPreferredPostcode$'
                     [typeaheadAsync]='true'
                     (typeaheadOnSelect)='selectPreferredPostcode($event)'
                     typeaheadOptionField='code'
                     typeaheadMinLength='2'
                     typeaheadWaitMs='300'>
            </div>
            <div class='buyer-v2-tags' *ngIf='searchRequest.preferredPostcodes?.length'>
              <div class='buyer-v2-tag' *ngFor='let postcode of searchRequest.preferredPostcodes'>
                <span>{{ postcode }}</span>
                <button type='button' class='buyer-v2-tag-remove' (click)='removePreferredPostcode(postcode)'>
                  <i class='fa fa-times'></i>
                </button>
              </div>
            </div>
          </section>

          <section class='buyer-v2-search-section' *ngIf='searchRequest.buyerCode !== "T"'>
            <div class='buyer-v2-search-title'>Living Area</div>
            <div class='buyer-v2-search-grid'>
              <input type='text' inputmode='numeric' nbInput fieldSize='tiny' fullWidth placeholder='Postcode'
                     [(ngModel)]='searchRequest.livingPostcode'
                     (ngModelChange)='onLivingPostcodeChange($event)'>
              <select class='select-custom' [(ngModel)]='searchRequest.livingDistrictId'
                      [disabled]='!searchRequest.livingPostcode'
                      (change)='onLivingDistrictChange(searchRequest.livingDistrictId)'>
                <option [ngValue]='undefined'>Suburb</option>
                <option *ngFor='let district of livingDistricts' [value]='district.districtId'>{{ district.name }}</option>
              </select>
              <select class='select-custom' [(ngModel)]='searchRequest.livingStreetId'
                      [disabled]='!searchRequest.livingDistrictId'>
                <option [ngValue]='undefined'>Street</option>
                <option *ngFor='let street of livingStreets' [value]='street.streetId'>{{ street.name }}</option>
              </select>
              <input nbInput fieldSize='tiny' fullWidth placeholder='Unit' [(ngModel)]='searchRequest.livingUnit'>
              <input nbInput fieldSize='tiny' fullWidth placeholder='House Number' [(ngModel)]='searchRequest.livingNumberFrom'>
            </div>
          </section>

          <section class='buyer-v2-search-section'>
            <div class='buyer-v2-search-title'>Enquiry Date</div>
            <div class='buyer-v2-search-grid'>
              <input type='date' nbInput fieldSize='tiny' fullWidth [(ngModel)]='searchFromEnqDate'>
              <input type='date' nbInput fieldSize='tiny' fullWidth [(ngModel)]='searchToEnqDate'>
            </div>
          </section>
        </nb-card-body>
        <nb-card-footer class='buyer-v2-search-footer'>
          <button type='button' nbButton size='small' (click)='cancelDetailSearch()'>Cancel</button>
          <button type='button' nbButton size='small' (click)='clearDetailSearch()'>Clear</button>
          <button type='button' nbButton size='small' status='primary' (click)='executeDetailSearch()'>Search</button>
        </nb-card-footer>
      </nb-card>
      <ngx-buyer-create-v2
        [hidden]='searchMode || isTenantEditorActive()'
        [cities]='cities'
        [taskTypes]='taskTypes'
        [taskStatuses]='taskStatuses'
        (editDone)='editDone($event)'
        (newDone)='newDone($event)'
        (reserveBuyer)='reserveBuyer($event)'
        (ownSet)='ownSet($event)'
        (navigateBuyerEvent)='navigateBuyer($event)'
        (backToList)='cancel()'>
      </ngx-buyer-create-v2>
      <ngx-tenant-buyer-create-v2
        #tenantBuyerCreateV2
        [hidden]='searchMode || !isTenantEditorActive()'
        [cities]='cities'
        [companies]='companies'
        [taskTypes]='taskTypes'
        [taskStatuses]='taskStatuses'
        (editDone)='editDone($event)'
        (newDone)='newDone($event)'
        (reserveBuyer)='reserveBuyer($event)'
        (ownSet)='ownSet($event)'
        (navigateBuyerEvent)='navigateBuyer($event)'
        (backToList)='cancel()'>
      </ngx-tenant-buyer-create-v2>
    </div>
  </div>
</div>
